import { render, staticRenderFns } from "./UiStringBrowse.vue?vue&type=template&id=2f6f1254&scoped=true&"
import script from "./UiStringBrowse.vue?vue&type=script&lang=js&"
export * from "./UiStringBrowse.vue?vue&type=script&lang=js&"
import style0 from "./UiStringBrowse.vue?vue&type=style&index=0&id=2f6f1254&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f1254",
  null
  
)

export default component.exports